export enum EAbExpActions {
	edit = 'edit',
	add = 'add',
	buckets = 'buckets',
	versionHistory = 'versionHistory',
	versionList = 'versionList',
	fixUsersBucket = 'fixUsersBucket',
	findUserBucket = 'findUserBucket'
}

export const METRICS_OPTIONS = [
	{ id: 'gmv', label: 'GMV' },
	{ id: 'rake', label: 'Rake' },
	{ id: 'cm', label: 'CM' },
	{ id: 'net_revenue', label: 'Net Revenue' },
	{ id: 'gross_deposit', label: 'Gross Deposit' },
	{ id: 'gross_withdrawal', label: 'Gross Withdrawal' },
	{ id: 'c2d', label: 'C2D' },
	{ id: 'paid_gameplays', label: 'Paid Gameplays' },
	{ id: 'd1_retention', label: 'D1 Retention' },
	{ id: 'd3_retention', label: 'D3 Retention' },
	{ id: 'd7_retention', label: 'D7 Retention' },
	{ id: 'd15_retention', label: 'D15 Retention' }
];

export const AB_TEST_DESC_MIN_LENGTH: number = 20;

export const AB_TEST_BUCKET_DESC_MIN_LENGTH: number = 10;

export const BUCKET_DESC_MIN_LENGTH_ERROR_MESSAGE: string = `Description should be at least ${AB_TEST_BUCKET_DESC_MIN_LENGTH} characters long`;

export const CREATE_AB_TEST_ENDPOINT: string = '/marketing/dashboard/abTest/createExperiment';

export const TOTAL_BUCKET_SHARE: number = 100;
